export default __webpack_public_path__ + "static/media/defaultTemplate_new2.b25fbdb2.png";